import * as z from "zod";

/** How many wins the home page row holds. */
export const HOME_WIN_SLOTS = 4;

/**
 * Saves the signed-in user's home page wins, in display order. Empty clears the
 * pick, so the page goes back to its derived default.
 */
export const saveHomeWins = {
  name: "saveHomeWins" as const,
  input: z.object({
    refs: z.array(z.string().min(1).max(64)).max(HOME_WIN_SLOTS),
  }),
  output: z.null(),
};
